// RecentReports.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFlask, 
  faDna, 
  faBaby, 
  faTooth, 
  faDroplet, 
  faEllipsisV, 
  faCircleDot,
  faCircleNotch,
  faCircleRight,
  faClock,
  faSpinner,
  faTimes,
  faCancel,
  faBowlFood,
  faBacteria,
  faHandsBubbles,
  faProcedures,
  faChartGantt,
  faOilCan,
  faVial, 
  faThunderstorm,
  faBoltLightning,
  faCapsules,
  faCircleNodes,
  faVials,
  faCarriageBaby,
  faUserCheck,
  faDashboard,
  faJugDetergent,
  faDesktopAlt,
  faBookMedical,
  faLink,
  faClinicMedical,
  faSearch,
  faStethoscope,
  faRunning
} from '@fortawesome/free-solid-svg-icons';

import ReactCountryFlag from "react-country-flag";

import './ReportGen.css';
import './RecentReports.css';

const RecentReports = ({ items }) => {
  // Map our report type codes (extracted from parentheses) to country codes.
  const codeMap = {
    KOR: "KR",     // Korea
    TUR: "TR",     // Turkey
    JPN: "JP",     // Japan
    CHN: "CN",     // China
    RUS: "RU",     // Russia
    ARB: "AE",     // Arabic (using United Arab Emirates as default)
    SPA: "ES",     // Spain
    ENG: "US"      // English (USA default)
  };

  // Map full language names to country codes as fallback
  const languageMap = {
    "English": "US",
    "Turkish": "TR",
    "Korean": "KR",
    "Japanese": "JP",
    "Chinese": "CN",
    "Russian": "RU",
    "Arabic": "AE",
    "Spanish": "ES"
  };

  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          className={`recent-item ${item.Status === 'Done' ? '' : 'not-done'}`}
        >
          {item.Status === 'Pending' && (
            <div className="ri-status ri-status-pending">
              <FontAwesomeIcon icon={faClock} />
              {item.Status}
            </div>
          )}
          {item.Status === 'Processing' && (
            <div className="ri-status ri-status-processing">
              <FontAwesomeIcon icon={faSpinner} className="spin-animation" />
              {item.Status}
            </div>
          )}
          {item.Status === 'Failed' && (
            <div className="ri-status ri-status-failed">
              <FontAwesomeIcon icon={faCancel} />
              {item.Status}
            </div>
          )}

          <div className="ri2">
            <div className="ri2in">
              {item.ReportType?.toLowerCase().includes('oncology') && (
                <FontAwesomeIcon icon={faFlask} />
              )}
              {item.ReportType?.toLowerCase().includes('sports performance') && (
                <FontAwesomeIcon icon={faRunning} />
              )}
              {item.ReportType?.toLowerCase().includes('genome') && (
                <FontAwesomeIcon icon={faDna} />
              )}
              {item.ReportType?.toLowerCase().includes('lifelong') && (
                <FontAwesomeIcon icon={faDna} />
              )}
              {item.ReportType?.toLowerCase().includes('lifeclub') && (
                <FontAwesomeIcon icon={faDna} />
              )}
              {item.ReportType?.toLowerCase().includes('newborn') && (
                <FontAwesomeIcon icon={faBaby} />
              )}
              {item.ReportType?.toLowerCase().includes('oral') && (
                <FontAwesomeIcon icon={faTooth} />
              )}
              {item.ReportType?.toLowerCase().includes('gut') && (
                <FontAwesomeIcon icon={faBacteria} />
              )}
              {item.ReportType?.toLowerCase().includes('lipidome') && (
                <FontAwesomeIcon icon={faFlask} />
              )}
              {item.ReportType?.toLowerCase().includes('transcriptome') && (
                <FontAwesomeIcon icon={faChartGantt} />
              )}
              {item.ReportType?.toLowerCase().includes('urine') && (
                <FontAwesomeIcon icon={faDroplet} />
              )}
              {item.ReportType?.toLowerCase().includes('carrier') && (
                <FontAwesomeIcon icon={faUserCheck} />
              )}
              {item.ReportType?.toLowerCase().includes('proteomics') && (
                <FontAwesomeIcon icon={faCircleNodes} />
              )}
              {item.ReportType?.toLowerCase().includes('plasma') && (
                <FontAwesomeIcon icon={faVial} />
              )}
              {item.ReportType?.toLowerCase().includes('exome') && (
                <FontAwesomeIcon icon={faStethoscope} />
              )}
              {!item.ReportType &&
                `${item.PatientFirstName?.[0]?.toUpperCase() || ''}${
                  item.PatientLastName?.[0]?.toUpperCase() || ''
                }`}
            </div>
          </div>
          <div
            className="ri3"
            onClick={() => item.ReportLink && window.open(item.ReportLink, '_blank')}
          >
            <div className="ri31">
              <div className="ri31T">
                <div>    
                {(item.PatientFirstName || item.PatientLastName) &&
                  `${
                    (item.PatientFirstName || '').length + (item.PatientLastName || '').length > 25
                      ? `${(item.PatientFirstName || '')} ${(item.PatientLastName || '')}`.slice(0, 22) + '...'
                      : `${item.PatientFirstName || ''} ${item.PatientLastName || ''}`
                  }`}
                  </div>
                <div>{item.SampleID || ''}</div>
              </div>
              <div className="ri31B">
                {item.ReportType && item.ReportType.match(/\((.*?)\)/) ? (() => {
                  const match = item.ReportType.match(/\((.*?)\)/);
                  const code = match[1].trim().toUpperCase();
                  // First try code-based mapping
                  let countryCode = codeMap[code];
                  
                  // If no mapping found and Language property exists, try language-based mapping
                  if (!countryCode && item.Language) {
                    countryCode = languageMap[item.Language] || codeMap.ENG;
                  }
                  
                  // Fallback to English if no mapping found
                  countryCode = countryCode || codeMap.ENG;
                  
                  return (
                    <ReactCountryFlag 
                      countryCode={countryCode}
                      svg
                      style={{ width: '1.5em', height: '1.5em', opacity: '0.5'
                       }}
                      title={`${countryCode} Flag`}
                    />
                  );
                })() : item.Language ? (() => {
                  // If no parentheses but Language property exists
                  const countryCode = languageMap[item.Language] || codeMap.ENG;
                  return (
                    <ReactCountryFlag 
                      countryCode={countryCode}
                      svg
                      style={{ width: '1.5em', height: '1.5em', opacity: '0.5'
                       }}
                      title={`${countryCode} Flag`}
                    />
                  );
                })() : <div></div>}


                {item.ReportType
                  ? item.ReportType.replace(/\(.*?\)/, '').trim() + ' '
                  : ''}
                <div className="ri31B2">{(item.Details || '').match(/!(.*?)!/)?.[1] || item.Company || ''}</div>
              </div>
            </div>
            <div className="ri32">
              <FontAwesomeIcon icon={faEllipsisV} className="outline-icon" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default RecentReports;
